var wx = require("weixin-js-sdk"); //微信sdk依赖
import {
    getWxConfig
} from "@/api/apiData";
//要用到微信API
function getJSSDK(title, desc) {
    var ip1 = window.location.href;
    var img = "http://gxrcwork.nccloudmedia.com/favicon.ico"; //分享内容显示的图片(图片必须是正方形的链接)
    // 调用后台接口换取参数
    getWxConfig().then(res => {
        if (res.code == 1) {
            var ua = navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                wx.config({
                    debug: res.data.debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: res.data.appId, // 必填，公众号的唯一标识
                    timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
                    signature: res.data.signature, // 必填，签名
                    jsApiList: res.data.jsApiList // 必填，需要使用的JS接口列表
                })
                wx.ready(function () {
                    // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
                    wx.updateAppMessageShareData({
                        title: title, // 分享标题
                        desc: desc, // 分享描述
                        link: ip1, // 分享链接
                        imgUrl: img, // 分享图标
                        success: function () { // 用户确认分享后执行的回调函数
                            // alert('分享朋友成功');
                            console.log("分享成功")
                        },
                        cancel: function () { // 用户取消分享后执行的回调函数
                            // alert('取消分享朋友');
                            console.log("取消分享")
                        },
                        fail: function () { // 用户分享失败后执行的回调函数
                            // alert('分享朋友失败');
                            console.log("分享朋友失败")
                        }
                    });
                    // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
                    wx.updateTimelineShareData({
                        title: title, // 分享标题
                        desc: desc, // 分享描述
                        link: ip1, // 分享链接
                        imgUrl: img, // 分享图标
                        success: function () { // 用户确认分享后执行的回调函数
                            // alert('分享朋友成功');
                            console.log("分享成功")
                        },
                        cancel: function () { // 用户取消分享后执行的回调函数
                            // alert('取消分享朋友');
                            console.log("取消分享")
                        },
                        fail: function () { // 用户分享失败后执行的回调函数
                            // alert('分享朋友失败');
                            console.log("分享朋友失败")
                        }
                    });
                })
                wx.error(function (result) {
                    console.log(JSON.stringify(result) + "微信验证失败");
                    // alert(JSON.stringify(res)+"微信验证失败");
                });
            }

        }
    })
}
export default {
    // 获取JSSDK
    getJSSDK: getJSSDK
}